import { render, staticRenderFns } from "./ReservedDataDialog.vue?vue&type=template&id=dca3f450&"
import script from "./ReservedDataDialog.vue?vue&type=script&lang=js&"
export * from "./ReservedDataDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports